import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDeviceAndLocation } from "../store/auth/selectors";
import { useLsqTrackingMutation } from "../store/ApiMutaion";
import DeeplinkLoginManager from "./DeeplinkComponets/DeeplinkLoginManager";
import DeeplinkRegisterManager from "./DeeplinkComponets/DeeplinkRegisterManager";
import { CONFIG_VARS } from "../constants/configuration";
import { useAnalytics } from "../contexts/AnalyticsContext";
// Assets
import mobileDash from "../assets/images/Deeplink/mobile/mobileDash.png";
import webDash from "../assets/images/Deeplink/web/webDash.png";
import mobileReports from "../assets/images/Deeplink/mobile/mobileReports.png";
import webReports from "../assets/images/Deeplink/web/webReports.png";
import mobileHots from "../assets/images/Deeplink/mobile/mobileHots.png";
import webHots from "../assets/images/Deeplink/web/webHots.png";
import mobileScore from "../assets/images/Deeplink/mobile/mobileScore.png";
import webScore from "../assets/images/Deeplink/web/webScore.png";
import mobileMath from "../assets/images/Deeplink/mobile/mobileMath.png";
import webMath from "../assets/images/Deeplink/web/webMath.png";
import mobileIeamsat from "../assets/images/Deeplink/mobile/mobileIeamsat.png";
import webIeamsat from "../assets/images/Deeplink/web/webIeamsat.png";

const DEEPLINK_INTENT = {
  LOGIN: "login",
  REGISTER: "register"
};

const DeepLink = ({ toggleTAndC, togglePAndP }) => {
  const { path } = useParams();
  const location = useLocation();
  const [trackLsqEvent] = useLsqTrackingMutation();
  const deviceDetials = useSelector(getDeviceAndLocation);
  const [deeplinkParams, setDeeplinkParams] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const analytics = useAnalytics();
  const [hasTrackedDeeplinkOpened, setHasTrackedDeeplinkOpened] = useState(false);

  const parseAndStoreParams = () => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.toString()) {
      const params = {
        id: queryParams.get("id"),
        password: queryParams.get("password"),
        exam_status: queryParams.get("exam_status"),
        exam: queryParams.get("exam"),
        crnId: queryParams.get("crnId"),
        eventId: queryParams.get("eventId"),
        utm_source: queryParams.get("utm_source"),
        utm_campaign: queryParams.get("utm_campaign"),
        utm_content: queryParams.get("utm_content"),
        utm_term: queryParams.get("utm_term")
      };

      if (Object.values(params).some((val) => val !== null)) {
        sessionStorage.setItem("deeplinkParams", JSON.stringify(params));
        return params;
      }
    }
    const storedParams = sessionStorage.getItem("deeplinkParams");
    return storedParams ? JSON.parse(storedParams) : null;
  };

  const parseAndStoreRegisterContext = () => {
    const queryParams = new URLSearchParams(location.search);
    const registerContext = {
      school_id: queryParams.get("school_id"),
      event: queryParams.get("event"),
      level: queryParams.get("level"),
      round: queryParams.get("round")
    };

    if (registerContext.school_id) {
      sessionStorage.setItem("deeplinkRegisterContext", JSON.stringify(registerContext));
      return registerContext;
    }

    const storedContext = sessionStorage.getItem("deeplinkRegisterContext");
    return storedContext ? JSON.parse(storedContext) : null;
  };

  const trackWhatsAppClick = async (params) => {
    if (
      !params.utm_source ||
      !params.utm_campaign ||
      !params.utm_content ||
      !params.utm_term ||
      params.utm_source !== "whatsapp"
    ) {
      return;
    }

    const trackingPayload = {
      platform: "whatsapp",
      crn_id: params.crnId,
      student_id: params.id,
      cta_type: "whatsapp_report_link",
      utm_source: params.utm_source,
      utm_campaign: params.utm_campaign,
      utm_content: params.utm_content,
      utm_term: params.utm_term
    };

    if (deviceDetials) {
      if (deviceDetials.latitude) {
        trackingPayload.latitude = deviceDetials.latitude;
      }
      if (deviceDetials.longitude) {
        trackingPayload.longitude = deviceDetials.longitude;
      }
      if (deviceDetials.ip_address) {
        trackingPayload.ip_address = deviceDetials.ip_address;
      }
    }

    if (params.crnId && params.eventId && params.id) {
      const baseUrl = CONFIG_VARS.environment.includes("prepord")
        ? "https://genius.devinfinitylearn.in"
        : "https://genius.infinitylearn.com";

      trackingPayload.cta_redirection_link =
        `${baseUrl}/deeplink/reports?crnId=${params.crnId}&eventId=${params.eventId}` +
        `&id=${params.id}&password=${params.password}`;
    }

    try {
      await trackLsqEvent(trackingPayload).unwrap();
    } catch (error) {
      console.error("Tracking failed:", error);
    }
  };

  const determineIntent = () => {
    if (path === "register") {
      return DEEPLINK_INTENT.REGISTER;
    }
    return DEEPLINK_INTENT.LOGIN;
  };

  const backgroundImage = useMemo(() => {
    const deviceType = window.innerWidth <= 768 ? "mobile" : "web";

    switch (path) {
      case "register":
        return deviceType === "mobile" ? `url(${mobileDash})` : `url(${webDash})`;
      case "dashboard":
        return deviceType === "mobile" ? `url(${mobileDash})` : `url(${webDash})`;
      case "reports":
        return deviceType === "mobile" ? `url(${mobileReports})` : `url(${webReports})`;
      case "exampage":
        switch (deeplinkParams?.exam) {
          case "hots":
            return deviceType === "mobile" ? `url(${mobileHots})` : `url(${webHots})`;
          case "score":
            return deviceType === "mobile" ? `url(${mobileScore})` : `url(${webScore})`;
          case "math":
            return deviceType === "mobile" ? `url(${mobileMath})` : `url(${webMath})`;
          case "ieamsat":
            return deviceType === "mobile" ? `url(${mobileIeamsat})` : `url(${webIeamsat})`;
          default:
            return deviceType === "mobile" ? `url(${mobileDash})` : `url(${webDash})`;
        }
      default:
        return deviceType === "mobile" ? `url(${mobileDash})` : `url(${webDash})`;
    }
  }, [path, deeplinkParams?.exam]);

  const initializeRegisterFlow = () => {
    const registerContext = parseAndStoreRegisterContext();
    if (registerContext) {
      setDeeplinkParams(registerContext);
    }
  };

  const initializeLoginFlow = () => {
    const params = parseAndStoreParams();
    if (params) {
      setDeeplinkParams(params);
      trackWhatsAppClick(params);
    }
  };

  useEffect(() => {
    const isRegisterFlow = path === "register";

    if (isRegisterFlow) {
      initializeRegisterFlow();
    } else {
      initializeLoginFlow();
    }

    setIsInitialized(true);
  }, [path, location.search]);

  useEffect(() => {
    if (isInitialized && path === "exampage" && deeplinkParams && !hasTrackedDeeplinkOpened) {
      const eventId = deeplinkParams.eventId || "";
      analytics.trackDeeplinkOpened(eventId);
      setHasTrackedDeeplinkOpened(true);
    }
  }, [isInitialized, path, deeplinkParams, hasTrackedDeeplinkOpened, analytics]);

  const intent = determineIntent();

  const renderManager = () => {
    switch (intent) {
      case DEEPLINK_INTENT.LOGIN:
        return (
          <DeeplinkLoginManager
            toggleTAndC={toggleTAndC}
            togglePAndP={togglePAndP}
            deeplinkParams={deeplinkParams}
            path={path}
          />
        );
      case DEEPLINK_INTENT.REGISTER:
        return (
          <DeeplinkRegisterManager
            toggleTAndC={toggleTAndC}
            togglePAndP={togglePAndP}
            deeplinkParams={deeplinkParams}
          />
        );
      default:
        return (
          <DeeplinkLoginManager
            toggleTAndC={toggleTAndC}
            togglePAndP={togglePAndP}
            deeplinkParams={deeplinkParams}
            path={path}
          />
        );
    }
  };

  if (!isInitialized) {
    return null;
  }

  return (
    <div style={{ minHeight: "100vh", width: "100%", position: "relative" }}>
      <div
        style={{
          backgroundImage: backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          minHeight: "calc(100vh - 80px)",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem 1rem"
        }}
      >
        {renderManager()}
      </div>
    </div>
  );
};

export default DeepLink;
